export default __webpack_public_path__ + "static/media/PJL01.4616b050.png";